<template>
  <VTooltip
    class="text-sm inline-block"
    :tooltip="tooltipText"
    content-class="inline-block rounded-full"
    on-click-close
    responsive
    direction="ssw"
    :offset="{ x: 8, y: 10 }"
  >
    <button
      ref="buttonRef"
      type="button"
      class="nav-icon w-[30px] h-[30px] relative rounded-full menu-text-color leading-none nav-icon-width"
      @click="$emit('click')"
    >
      <slot>
        <VIcon
          :icon="icon"
          color="menu-text-color"
          class="!leading-none align-middle"
          :class="iconClass"
        />
      </slot>

      <div
        v-if="count > 0"
        class="absolute text-white text-[0.6rem] h-[15px] min-w-[15px] px-1 py-0.75 bottom-4 left-[1.125rem] font-semibold rounded-full bg-red-1"
      >
        {{ count }}
      </div>
    </button>
  </VTooltip>
</template>
<script>
import { ref } from 'vue';
// Components
import VTooltip from '@/components/VTooltip';
import VIcon from '@/components/VIcon';
export default {
  components: {
    VIcon,
    VTooltip
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    tooltipText: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    buttonHoverColour: {
      type: String,
      default: 'white'
    },
    iconClass: {
      type: [String, Array, Object],
      default: ''
    }
  },
  emits: ['click'],
  setup () {
    const buttonRef = ref(null);

    return {
      buttonRef
    };
  }
};
</script>
<style scoped lang="scss">
  .nav-icon:hover {
    background-color: v-bind(buttonHoverColour) !important;
  }
</style>
